import { useGetMarketInfoQuery } from '@/features/marketInfo/marketInfoApi';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import MarketChart from '@/shared/components/MarketChart/MarketChart';
import { DEFAULT_MARKET } from '@/shared/constants/constants';
import { EntityId } from '@reduxjs/toolkit';
import { Trans, useTranslation } from 'react-i18next';
import styles from './MarketDetail.module.css';
import CryptoTitle from '@/shared/components/CryptoTitle/CryptoTitle';
import React from 'react';
import { getAssetName } from '@/shared/helpers/assets';
import { assets } from '@/shared/config/assets';

type Props = {
  marketId?: EntityId;
};

const MarketDetail: React.FC<Props> = ({ marketId }) => {
  const { t } = useTranslation();

  const selectedMarket = marketId ? marketId : DEFAULT_MARKET;
  const { data: marketInfo, isLoading } = useGetMarketInfoQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: 10 * 1000 // every 10s
  });

  const basicCode = marketInfo?.entities[selectedMarket]?.basicCode;

  // TODO: If no marketdata, what should we show?
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return marketInfo ? (
    <>
      <CryptoTitle assetId={basicCode}>
        {getAssetName(basicCode)} {t('markets.details.price')}
      </CryptoTitle>
      <MarketChart selectedMarket={selectedMarket} marketInfo={marketInfo} />
      <div className={styles.generalInfoWrapper}>
        <h2>
          {t('markets.details.general_information')} {getAssetName(basicCode)}
        </h2>
        <p className={styles.generalInfo}>{t(assets[basicCode || '']?.description)}</p>
      </div>
    </>
  ) : (
    <div className={styles.noDataAvailable}>
      <Trans i18nKey="error.internal.body" />
    </div>
  );
};

export default MarketDetail;
